module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2022-10-18 at 9.38.44 AM.18de7ec9.jpeg";